<template>
    <div style="height:100%" class="home">
        <div class="dashborad-swiper">
            <el-carousel :interval="4000" height="4rem" style="position:relative">
                <el-carousel-item v-for="(item, index) in imglist" :key="index">
                    <img :src="item.src" alt="" width="100%" height="100%" fit="fit">
                    <div class="banner-brand">
                        <img class="banner-brand-brand background" :src="item.brand" fit="contain" /><br />
                        <el-image class="banner-brand-slogan background" :src="item.slogan" fit="contain" />
                        <div class="banner-brand-content" v-html="item.content"></div>
                        <el-button class="button" :class="{ 'firstBtn': index === 0 }" @click="handleJump(item)">
                            了解更多
                        </el-button>
                    </div>
                </el-carousel-item>
            </el-carousel>
        </div>
        <div class="page_content flex-between dashborad-introduce" style="background-color: #fff;">
            <div class="dashborad-introduce-item flex-left" v-for="item in introduces" :key="item.index">
                <img :src="item.url" alt="" style="width: 0.6rem; height: 0.6rem;" />
                <div class="dashborad-introduce-main">
                    <div class="dashborad-introduce-main-title">
                        {{ item.title }}
                    </div>
                    <div class="dashborad-introduce-main-content">
                        {{ item.content }}
                    </div>
                </div>
            </div>
        </div> 
        <div 
            class="dashborad-bg" 
            v-for="(item, index) in homeBgList" 
            :key="index"
            :class="{ 'last-bg-item': index === homeBgList.length - 1 }"
            :style="{ 'background-image': `url('${item.url}')` }"
            v-animate-on-scroll
            >
            <div class="bg-content" :class="getPositionClass(index)">
                <div class="bg-title" :class="{ 'even-title': index % 2 === 0, 'odd-title': index % 2 !== 0 }">{{ item.title }}</div>
                <div class="bg-label" :class="{ 'even-label': index % 2 === 0, 'odd-label': index % 2 !== 0  }">{{ item.label }}</div>
            </div>
        </div>
    </div>
</template>
  
<script>
/* eslint-disable */
import api from '@/api/api'
import photoList from './photoList.vue'
export default {
    components: { photoList },
    data() {
        return {
            clickIndex: 0,
            show: {},
            imglist: [
                { 
                    id: 0, 
                    brand: require('@/assets/images/2025new/banner1-title1.png'),
                    slogan: require('@/assets/images/2025new/banner1-titlesmall.png'),
                    src: require('@/assets/images/2025new/banner1.png') 
                },
            ],
            introduces: [
                { 
                    url: require('@/assets/images/2025new/introduce1.png'), 
                    title: '强大的AI算力', 
                    content: '当前算力已达1000Pops@INT16' 
                },
                { 
                    url: require('@/assets/images/2025new/introduce3.png'), 
                    title: '丰富的AI算法', 
                    content: '支持150多种市面主流大模型的适配' 
                },
                { 
                    url: require('@/assets/images/2025new/introduce4.png'), 
                    title: '一站式生态服务', 
                    content: '建设、运营、应用三阶段统筹协同' 
                },
                { 
                    url: require('@/assets/images/2025new/introduce2.png'), 
                    title: '7*24小时服务', 
                    content: '专业团队提供完善的服务' 
                },
            ],
            photoList: [],
            homeBgList: [
                { 
                    url: require('@/assets/images/2025new/banner2.png'), 
                    title: '国产化平台生态践行者AI工程化践行者', 
                    label: '国内智算生态建设先驱者，专注人工智能基础技术与云算一体平台，为央国企、产业龙头及科研院校提供国产软硬件智能化全栈服务。' 
                },
                { 
                    url: require('@/assets/images/2025new/banner3.png'), 
                    title: '自主可控的异构算力平台', 
                    label: '易构算力平台引领绿色低碳新标杆，提供数据平台、软件存储及异构算网全栈配套，实现公域托管与私域一站式建设的自主可控生态。' 
                },
                { 
                    url: require('@/assets/images/2025new/banner4.png'), 
                    title: '算力服务出海，助力全球新质生产力', 
                    label: '以国产化算力为核心，将AI Agent与智能平台打包成高性价比解决方案，首站新加坡、日本，逐步拓展中东欧洲，推动“一带一路”芯动能。' 
                },
                { 
                    url: require('@/assets/images/2025new/banner5.png'), 
                    title: '全栈兼容·大模型API服务开放赋能', 
                    label: '深度兼容主流AI生态，提供十亿至千亿参数大模型解决方案，基于云边协同一体机与多模态API能力，助力企业快速集成智能应用，加速国产化新质生产力落地。' 
                },
            ],
        }
    },
    mounted() {
        this.queryList();
        document.body.scrollTop = document.documentElement.scrollTop = 0;
        
        // 初始检查所有元素
        setTimeout(() => {
            this.$nextTick(() => {
                const elements = document.querySelectorAll('.dashborad-bg');
                elements.forEach(el => {
                    if (el.__checkVisibility__) {
                        el.__checkVisibility__();
                    }
                });
            });
        }, 0);
    },
    methods: {
        handleJump(e) {
            if (e.id === 0) {
                this.$router.push('/aicenter')
            } else if (e.id === 1) {
                this.$router.push('/aiCase')
            } else {
                this.$router.push('/industryCases')
            }
        },
        chooseSolution(e, i) {
            this.clickIndex = i
            this.show = e
        },
        queryList() {
            api.newslist({
                pageNum: 1,
                pageSize: 999
            }).then(res => {
                if (res.code === 200 && res.data.list) {
                    this.photoList = res.data.list.slice(0, 8)
                }
            })
        },
        getPositionClass(index) {
            return index % 2 === 0 ? 'content-left' : 'content-right';
        }
    },
    directives: {
        'animate-on-scroll': {
            inserted: function(el) {
                el.style.opacity = '0';
                el.style.transform = 'translateY(0.7rem)';
                el.style.transition = 'opacity 0.9s ease, transform 0.9s ease';
                el.style.visibility = 'hidden';
                const checkVisibility = () => {
                    const rect = el.getBoundingClientRect();
                    const windowHeight = window.innerHeight || document.documentElement.clientHeight;
                    
                    if (rect.top <= windowHeight - 120) {
                        el.style.opacity = '1';
                        el.style.transform = 'translateY(0)';
                        el.style.visibility = 'visible'; // 显示元素
                    } else {
                        if (rect.bottom < 0 || rect.top > windowHeight) {
                            el.style.opacity = '0';
                            el.style.transform = 'translateY(0.7rem)';
                            el.style.visibility = 'hidden'; // 隐藏元素
                        }
                    }
                };
                
                // 保存检查函数引用
                el.__checkVisibility__ = checkVisibility;
                
                // 初始检查
                checkVisibility();
                
                // 监听滚动事件
                window.addEventListener('scroll', checkVisibility);
                
                // 监听窗口大小变化
                window.addEventListener('resize', checkVisibility);
                
                // 组件销毁时移除监听
                el.__onScrollDestroy__ = () => {
                    window.removeEventListener('scroll', checkVisibility);
                    window.removeEventListener('resize', checkVisibility);
                };
            },
            unbind: function(el) {
                if (el.__onScrollDestroy__) {
                    el.__onScrollDestroy__();
                    delete el.__onScrollDestroy__;
                }
                if (el.__checkVisibility__) {
                    delete el.__checkVisibility__;
                }
            }
        }
    }
}
</script>
  
<style lang="scss">
  .home {
    .el-carousel__mask {
      background: #eff0f5;
    }
  
    .el-button--small {
      padding: 0.09rem; /* 9px */
      font-size: 0.12rem; /* 12px */
    }
  
    .banner-brand {
      position: absolute;
      top: 1rem; /* 100px */
      z-index: 9999;
      color: #fff;
      width: 100%;
      margin-left: 3rem; /* 300px */
  
      .button {
        width: 1rem; /* 100px */
        height: 0.36rem; /* 36px */
        cursor: pointer;
        font-weight: 600;
        font-size: 0.14rem; /* 14px */
        margin-top: 0.4rem; /* 40px */
        font-family: '黑体';
        letter-spacing: 0.03rem; /* 3px */
      }
  
      .button:hover {
        box-shadow: 0px 0px 5px 1px #95b3da;
      }
  
      &-brand {
        width: 6.2rem; /* 620px */
        height: 0.7rem; /* 70px */
      }
  
      &-slogan {
        height: 0.26rem; /* 26px */
        position: relative;
        margin: 0.3rem 0; /* 30px */
      }
  
      &-content {
        font-size: 0.14rem; /* 14px */
        line-height: 0.22rem; /* 22px */
        color: #ebebebe5;
        font-weight: 500;
        width: 7rem; /* 700px */
        letter-spacing: 1px;
      }
    }
  
    .dashborad-introduce {
      height: 1rem; 
      position: absolute;
      top:4.4rem;
      width: 12.8rem;
      left: calc(50% - 6.4rem);
      margin: 0 auto;
      z-index: 999;
      border-radius: 0.04rem; /* 4px */
      box-shadow: 0px 0px 24px 0px rgba(107, 107, 107, 0.2);
  
      &-item {
        width: 100%;
        padding: 0.08rem 0.3rem; /* 8px 30px */
        margin: 0.08rem 0; /* 8px */
        border-left: 1px solid #D9E4F4;
      }
  
      &-item:nth-of-type(1) {
        border-left: 0;
      }
  
      &-main {
        position: relative;
        left: 0.12rem; /* 12px */
        &-title {
          font-size: 0.16rem; 
          color: #0061E3; 
          font-weight: 600; 
          margin-top: 0.06rem;
        }
        &-content {
          font-size: 0.12rem; 
          color: #3F4D62; 
          margin-top: 0.1rem;
        }
      }
    }
  
    .dashborad-bg {
      position: relative;
      width: 100%;
      height: 4.2rem; /* 420px */
      background-position: center;
      background-repeat: no-repeat;
      background-size: cover;
      overflow: hidden;
      z-index: 1;
      transition: opacity 0.8s ease, transform 0.8s ease, visibility 0.8s ease;
      
      .bg-content {
        position: absolute;
        top: 50%;
        transform: translateY(-50%);
        width: 50%; /* 基于父容器宽度百分比 */
        padding: 0 5%; /* 百分比单位 */
        
        &.content-left {
          left: 2rem; /* 固定左侧定位 */
          text-align: left;
        }
        
        &.content-right {
          right: 2rem; /* 固定右侧定位 */
          text-align: right;
        }
      }
      
      .even-title {
        color: #0061E3;
        position: relative; 
        padding-left: 0.16rem;

        &::before {
            content: '';
            position: absolute;
            left: 0;
            top: 0.07rem;
            width: 0.05rem; 
            height: 0.3rem; 
            background: linear-gradient(to bottom, #0061E3, #F5F5F5); 
        }
      }
      .odd-title {
        color: #F5F5F5;
        position: relative; 
        padding-left: 0.03rem;
        width: 3rem;
        left: 3.4rem;
        &::before {
            content: '';
            position: absolute;
            left: 0;
            top: 0.09rem;
            width: 0.05rem; 
            height: 0.27rem; 
            background: linear-gradient(to bottom, #ffffffe5, #f5f5f5da, #61616173); 
        }
      }
      .even-label {
        color: #333;
      }
      .odd-label{
        color: #f5f5f5;
        float: right;

      }
      
      /* 统一设置其他样式 */
      .bg-title {
        font-size: 0.26rem; /* 16px */
        font-weight: bold;
        margin-bottom: 0.4rem; /* 20px */
        text-shadow: 0 2px 10px rgba(0,0,0,0.3);
      }
      
      .bg-label {
        width: 6rem;
        font-size: 0.16rem; /* 14px */
        line-height: 1.6; /* 行高倍数 */
        text-shadow: 0 1px 5px rgba(0,0,0,0.2);
      }
    }
    .last-bg-item {
      .bg-content {
        /* 居中布局 */
        left: 50%;
        transform: translate(-50%, -50%);
        width: 80%; /* 可调整的居中宽度 */
        text-align: center;
        top:1.5rem;

        .bg-title {
          position: relative;
          display: flow;
          width: 4.8rem;
          left: 5.1rem;
          /* 标题两侧渐变矩形 */
          &::before,
          &::after {
            content: '';
            position: absolute;
            top: 50%;
            transform: translateY(-50%);
            width: 0.5rem; /* 矩形长度 */
            height: 0.05rem; /* 矩形高度 */
          }

          &::before {
            left: -0.4rem; /* 左侧距离标题0.4rem */
            background: linear-gradient(to right, #333, #fff); /* 左到右渐变 */
          }

          &::after {
            right: -0.4rem; /* 右侧距离标题0.4rem */
            background: linear-gradient(to left, #333, #fff); /* 右到左渐变 */
          }
        }

        .bg-label {
          width: 8rem; /* 标签宽度6rem */
          margin: 0.1rem auto; /* 水平居中 + 顶部间距 */
          text-align: center;
          float: none; /* 移除浮动 */
          line-height: 1.6; /* 保持行高 */
        }
      }

      /* 最后一条的标题/标签颜色继承原有逻辑，但强制居中 */
      .even-title,
      .odd-title,
      .even-label,
      .odd-label {
        text-align: center;
      }
    }
  }
@media screen and (min-width: 2000px) {
   .home{
      .banner-brand{
          .button{
            font-size: 0.13rem;
          }
      }
      .dashborad-introduce{
        &-main {
          &-title {
            font-size: 0.15rem; 
          }
          &-content {
            font-size: 0.11rem; 
          }
        }
      }
      .dashborad-bg{
        .bg-title {
          font-size: 0.24rem; /* 16px */
        }
        
        .bg-label {
          font-size: 0.14rem; /* 14px */
        }
      }
   }
}
</style>